import React from "react";
import { Col, Row } from "antd";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ProductCardDesign from "./ProductCardDesign";
import CardBox from "components/CardBox/index";




const ProductCard = ({ productsData }) => {
  const options1 = {
    dots: true,
    infinite: false,
    speed: 500,
    marginLeft: 10,
    marginRight: 10,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: false,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <div className="user-profile-product">
      <Row>
        <Col span={24}>
          <CardBox>
            <div className="myexim-table-title gx-mb-4">Products</div>
            <Slider {...options1}>
              {productsData?.map((testimonal, index) => (
                <ProductCardDesign
                  key={index}
                  testimonial={testimonal}
                  isFromUserProfile={true}
                />
              ))}
            </Slider>
          </CardBox>
        </Col>
      </Row>
    </div>
  );
};

export default ProductCard;
